export default {
  rowModal: {
    title: 'מצאנו שגיאות בקובץ {1}',
    saveButton: 'מאושר',
    cancelButton: 'לא מאושר',
    cancelProcessButton: 'ביטול קליטת קובץ',
    lines: {
      row: 'שורה',
      column: 'עמודה',
      actualValue: 'הערך שנמצא',
      expectedValue: 'הערך המחושב',
    },
  },
  finishModal: {
    label: 'סיימת לטפל בכל השגיאות בקובץ {1}',
    message: 'המערכת תמשיך כעת את קליטת הקובץ',
  },
};
